module.exports = __webpack_public_path__ + "img/5a7263d.png";